export enum ViewModes {
    LIST = 'list',
    MOBILE = 'mobile',
    DESKTOP = 'desktop',
    FRAMELESS = 'frameless',
    NONE = 'none',
}
